import { useMemo } from "react";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useCreditReportDetails } from "../../../CustomHooks/Queries";

import { modalVariants } from "../../../Utils/constants";

import { PersonHoldingHouseRoof } from "../../../Assets/Images";

export default function renderCreditBuilderLearnMore(modalContext) {
  const { updateModalComponent, setModalVariant, setModalClassName, setModalAriaLabel } = modalContext;

  updateModalComponent(CreditBuildLearnMore);
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("hide-header");
  setModalAriaLabel?.("How Credit Builder works");
}

const CreditBuildLearnMore = () => {
  const { onModalClose } = useModalContext();

  const { data: creditReporting } = useCreditReportDetails();

  const creditBuilderContent = useMemo(() => {
    return creditReporting?.data?.data.credit_builder.content;
  }, [creditReporting?.data?.data.credit_builder.content]);

  const creditBuilderBenefits = [
    creditBuilderContent.onboarding1,
    creditBuilderContent.onboarding2,
    creditBuilderContent.onboarding3,
  ];

  return (
    <>
      <div className="modal-image credit-builder-learn-more mb-4">
        <img src={PersonHoldingHouseRoof} alt="" />
      </div>
      <div className="modal-dialog-content">
        <h3 className="modal-status-title mb-3">How Credit Builder Works</h3>
        <div className="numbered-list">
          {creditBuilderBenefits.map((benefit, idx) => (
            <div key={idx} className="list-item">
              <span className="list-item-badge">✅</span>
              <div className="list-item-content">
                <p className="text-lg-medium color--mist mb-0">{benefit}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={onModalClose}>Got it</PrimaryButton>
      </div>
    </>
  );
};
